// extracted by mini-css-extract-plugin
export default {"visibleLinksContainer":"brand-global-nav-sidebar-VisibleLinks__visibleLinksContainer--1Sjcn"};